import React from "react";
import {
  Modal,
  ModalBody,
  ModalHeader, 
} from "reactstrap";
import "./index.css";
export default function DeliveryOrder({
  openPdf,
  setOpenPdf,
  doUrl,
}) {

  return (
      <Modal isOpen={openPdf} size="xl" className="full-height-modal">
        <ModalHeader
          toggle={() => setOpenPdf(false)}
          style={{ fontSize: "12px" }}
        >
         <span style={{ fontSize: "16px" }}>Preview Delivery Order</span>
        </ModalHeader>

        <ModalBody>
          <iframe
            title="DeliveryOrder"
            src={doUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </ModalBody>
      </Modal>
  );
}
